/**
 * 保存済み出荷依頼書詳細から印刷用 viewModel を組み立てる。
 */
import { buildRequestFormViewModel } from './requestFormUtils';

export function buildViewModelFromShipRequestDetail(detail) {
  if (!detail) return null;
  const lines = Array.isArray(detail.lines) ? detail.lines : [];
  const rows = lines.map((ln) => {
    const snap = ln.snapshot || {};
    return {
      ...snap,
      key:
        snap.key ||
        `${ln.hacchu_code}-${ln.hacchu_datacode}-${ln.split_no || 0}`,
    };
  });
  const vm = buildRequestFormViewModel(rows);
  if (!vm) return null;
  const issuedAt = detail.issued_at ? String(detail.issued_at).slice(0, 10) : null;
  vm.header = {
    ...vm.header,
    request_no: detail.request_no || '',
    issued_date: issuedAt || vm.header.issued_date,
    issued_by: detail.issued_by || vm.header.issued_by,
  };
  vm.meta = {
    request_no: detail.request_no,
    is_latest: detail.is_latest,
    status: detail.status,
    arrange_status: detail.arrange_status,
  };
  return vm;
}
